/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterAvailability } from './ClaimCenterAvailability';
import {
    ClaimCenterAvailabilityFromJSON,
    ClaimCenterAvailabilityFromJSONTyped,
    ClaimCenterAvailabilityToJSON,
} from './ClaimCenterAvailability';

/**
 * 
 * @export
 * @interface ClaimReservationAvailability
 */
export interface ClaimReservationAvailability {
    /**
     * 
     * @type {Array<ClaimCenterAvailability>}
     * @memberof ClaimReservationAvailability
     */
    availability: Array<ClaimCenterAvailability>;
}

/**
 * Check if a given object implements the ClaimReservationAvailability interface.
 */
export function instanceOfClaimReservationAvailability(value: object): value is ClaimReservationAvailability {
    if (!('availability' in value) || value['availability'] === undefined) return false;
    return true;
}

export function ClaimReservationAvailabilityFromJSON(json: any): ClaimReservationAvailability {
    return ClaimReservationAvailabilityFromJSONTyped(json, false);
}

export function ClaimReservationAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservationAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'availability': ((json['availability'] as Array<any>).map(ClaimCenterAvailabilityFromJSON)),
    };
}

export function ClaimReservationAvailabilityToJSON(value?: ClaimReservationAvailability | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'availability': ((value['availability'] as Array<any>).map(ClaimCenterAvailabilityToJSON)),
    };
}

